/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useForm } from "react-hook-form";
import { Box, Grid, Typography, useMediaQuery } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/styles';
import { Button } from '@lc/legacy/src/Components';
import { InputField } from '@lc/legacy/src/Components';
import { cpf as cpfValidator, cnpj as cnpjValidator } from 'cpf-cnpj-validator';
import { MaskedPattern } from 'imask';
import api from 'api';
import { useSnackbar } from 'contexts';

import { booking } from 'helpers';
import BackButton from 'components/BackButton';

const useStyles = makeStyles({
  main: {
    margin: '20px 20px',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: '25px 0px 50px 0px'
  },
  marginSection: {
    marginTop: '14px',
  },
  marginContent: {
    marginTop: '12px',
  },
  hr: {
    border: '0',
    height: '1px',
    backgroundColor: '#a6a6a673',
  },
  gridList: {
    display: 'flex',
    flexWrap: 'nowrap',
    transform: 'translateZ(0)',
    overflow: 'auto',
    marginTop: '12px',
  },
  gridListImage: {
    width: '100px',
    margin: '10px',
  },
  priceLabel: {
    backgroundColor: '#f6f6f6',
    color: '#797979',
    padding: '8px 10px',
    borderRadius: '5px',
  },
  dashLi: {
    listStyle: 'none',
    marginLeft: '-16px',
    textTransform: 'capitalize',
  },
  btnCollapse: {
    padding: '0 !important',
    display: 'flex',
    justifyContent: 'space-between',
  },
});

const RentForm = ({ id, setShowAddress, onClose }) => {
  const [, setMessage] = useSnackbar();
  const xsSize = useMediaQuery(useTheme().breakpoints.down('sm'));
  const [states, setStates] = useState([]);
  const [razaoSocial, setRazaoSocial] = useState(false);
  const { register, handleSubmit, errors, setError, setValue, getValues, clearError } = useForm();

  const getStates = async setStates => {
    const [data, error] = await api.getAllStatesBr();
    if (!error) setStates(data.sort((a, b) => a.nome.localeCompare(b.nome)));
  };

  const getLatLng = async (result) => {
    const [distance, errorGoogle] = await api.getPlaceDistance(result);

    if (distance <= 50000) {
      clearError('zipcode')
      console.log('limpou2s');
    } else {
      setValue('zipcode', '')
      formValues.address = {}
      setMessage({ message: `O aluguel deste equipamento está disponível apenas para fretes com distância menor ou igual a 50km`, variant: 'warning' });
      console.log('setou');
      setError('zipcode')
    }
  }

  const { t } = useTranslation(['register']);
  let cpfCnpjInputRef;
  const [formValues, setFormValues] = useState({
    cnpj: '',
    address: {}
  });
  const classes = useStyles();

  const [cpfCnpjInvalid, setCpfCnpjInvalid] = useState('');

  const cpfCnpj = getValues()?.cpfCnpj || '';

  const legalEntity = cpfCnpj.length > 14;
  const invalidCpfCnpjErrorMessage = legalEntity
    ? t('feedbacks:invalidCnpjAlert')
    : t('feedbacks:invalidCpfAlert');

  useEffect(() => {
    if (cpfCnpjInputRef && cpfCnpj) {
      // mantém focus no campo de cpf/cnpj quando há alteração na máscara utilizada
      // https://github.com/nosir/cleave.js/issues/428
      cpfCnpjInputRef.focus();
    }
  }, [legalEntity]);

  useEffect(() => {
    getStates(setStates);
  }, []);

  const getCNPJInfo = async (cnpj) => {
    const [data, error] = await api.getCNPJInfo(cnpj.replace(/\D/g, ''));
    if (!error) {
      setFormValues({
        ...formValues,
        cnpj: data
      });
    } else {
      setMessage({ message: `CEP Inválido`, variant: 'warning' });
    }
  }

  const cpfCnpjIsValid = () =>
    (legalEntity && cnpjValidator.isValid(cpfCnpj)) ||
    (!legalEntity && cpfValidator.isValid(cpfCnpj));

  const onSubmit = async data => {

    if (!cpfCnpjIsValid()) {
      setError('cpfCnpj');
      setCpfCnpjInvalid(true);
      return;
    }

    if (!getValues().zipcode) {
      setError('zipcode')
      return;
    }
    if (!getValues().street) {
      setError('street')
      return;
    }
    if (!getValues().number) {
      setError('number')
      return;
    }
    if (!getValues().neighborhood) {
      setError('neighborhood')
      return;
    }
    if (!getValues().city) {
      setError('city')
      return;
    }
    if (!getValues().state) {
      setError('state')
      return;
    }

    if (Object.keys(errors).length !== 0) return;


    clearError('street')
    clearError('number')
    clearError('neighborhood')
    clearError('city')
    clearError('state')
    setCpfCnpjInvalid(false);

    booking.setRentAddress(id, { cnpj: formValues.cnpj, address: formValues.address })
    setShowAddress(false)
    window.scrollTo(0, 0);
  };
  return (
    <>
      <BackButton onClick={onClose} />
      <Grid item xs={12} style={{ marginTop: '15px', paddingLeft: '20px' }}>
        <Typography variant={'body1'} color="textPrimary"><b>Por favor, preencha os campos abaixo para solicitar a locação de equipamentos.</b></Typography>
      </Grid>
      <div className={classes.main}>

        <Grid container spacing={0}>
          <Grid item xs={12} style={{ marginBottom: '16px' }}>
            <Typography variant={'body2'} color="textPrimary"><b>Informe seu CNPJ</b></Typography>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <InputField
                color="secondary"
                label="CPF/CNPJ"
                name="cpfCnpj"
                error={!!errors.cpfCnpj}
                helperText={errors.cpfCnpj?.message || t('feedbacks:requiredField')}
                fullWidth
                value={formValues.cnpj.cnpj}
                inputProps={{
                  ref: register({
                    required: true,
                    validate: value => {
                      const result =
                        (legalEntity && cnpjValidator.isValid(value)) ||
                        (!legalEntity && cpfValidator.isValid(value));

                      return result || t('feedbacks:invalidCpfOrCnpjAlert');
                    },
                  }),
                  onChange: ({ target: { value } }) => {
                    const cpfcnpjformatted = new MaskedPattern({
                      mask: value.length > 14 ? '00.000.000/0000-00' : '000.000.000-00',
                    }).resolve(value);

                    setFormValues({
                      ...formValues,
                      cnpj: { ...formValues.cnpj, cnpj: cpfcnpjformatted }
                    });

                    clearError('cpfCnpj');

                    if (value.length === 18 && cnpjValidator.isValid(value)) {
                      setRazaoSocial(true)
                      getCNPJInfo(value)
                    } else {
                      setRazaoSocial(false)
                    }
                  },
                }}
              />
            </Grid>
            {razaoSocial && <Grid item xs={12} md={12}>
              <InputField
                color="secondary"
                label="Razão Social"
                placeholder="Razão Social"
                name="razaosocial"
                error={!!errors.street}
                helperText="Razão Social"
                value={formValues.cnpj.nome || ""}
                disabled
                inputProps={{ ref: register({ required: true }) }}
                fullWidth
              />
            </Grid>}
          </Grid>
          <Grid item xs={12} style={{ marginTop: '50px', marginBottom: '16px' }}>
            <Typography variant={'body2'} color="textPrimary"><b>Qual o endereço de entrega do equipamento?</b></Typography>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <InputField
                withMask
                color="secondary"
                data-testid="form-zipcode"
                label="CEP"
                placeholder="Informe o CEP"
                name="zipcode"
                error={!!errors.zipcode}
                helperText="CEP Inválido"
                value={formValues.address.zipcode || ""}
                fullWidth
                inputProps={{
                  ref: register({ required: true, pattern: /^\d{5}-\d{3}$/ }),
                  options: { blocks: [5, 3], delimiters: ["-"] },
                }}
                onChange={async (e) => {
                  setFormValues({
                    ...formValues,
                    address: { ...formValues.address, zipcode: e.target.value },
                  });

                  if (e.target.value.length === 9) {
                    try {
                      const result = await api.getAddressByZipCode(e.target.value);
                      getLatLng(result)

                      setFormValues({
                        ...formValues,
                        address: {
                          ...formValues.address,
                          zipcode: e.target.value,
                          state: result.state,
                          city: result.city,
                          country: 'Brasil',
                          street: result.street,
                          neighborhood: result.neighborhood,
                        },
                      });
                      console.log('limpous');
                      clearError('zipcode')
                    } catch (error) {
                      setMessage({ message: `CEP Invalido`, variant: 'warning' });

                    }


                  }
                }}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <InputField
                color="secondary"
                label="Logradouro"
                placeholder="Informe o nome da rua ou avenida"
                name="street"
                error={!!errors.street}
                helperText="Endereço inválido"
                value={formValues.address.street || ""}
                inputProps={{ ref: register({ required: true }) }}
                fullWidth
                onChange={(e) => {
                  setFormValues({
                    ...formValues,
                    address: { ...formValues.address, street: e.target.value },
                  });
                  clearError('street')
                }}
              />
            </Grid>
            <Grid item xs={12} md={5}>
              <InputField
                color="secondary"
                label="Número"
                placeholder="Informe o número"
                name="number"
                error={!!errors.number}
                helperText="Número inválido"
                value={formValues.address.number || ""}
                inputProps={{ ref: register({ required: true }) }}
                fullWidth
                onChange={(e) => {
                  setFormValues({
                    ...formValues,
                    address: { ...formValues.address, number: e.target.value },
                  });
                  clearError('number')
                }}
              />
            </Grid>
            <Grid item xs={12} md={7}>
              <InputField
                color="secondary"
                label="Complemento"
                placeholder="Informe o complemento"
                name="complement"
                error={!!errors.complement}
                helperText="Complemento inválido"
                value={formValues.address.complement || ""}
                fullWidth
                onChange={(e) => {
                  setFormValues({
                    ...formValues,
                    address: { ...formValues.address, complement: e.target.value },
                  });
                  clearError('complement')
                }}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <InputField
                color="secondary"
                label="Bairro"
                placeholder="Informe o bairro"
                name="neighborhood"
                error={!!errors.neighborhood}
                helperText="Bairro inválido"
                value={formValues.address.neighborhood || ""}
                inputProps={{ ref: register({ required: true }) }}
                fullWidth
                onChange={(e) => {
                  setFormValues({
                    ...formValues,
                    address: { ...formValues.address, neighborhood: e.target.value },
                  });
                  clearError('neighborhood')
                }}
              />
            </Grid>
            <Grid item xs={12} md={7}>
              <InputField
                color="secondary"
                label="Cidade"
                placeholder="Informe a cidade"
                name="city"
                error={!!errors.city}
                helperText="Cidade inválido"
                value={formValues.address.city || ""}
                inputProps={{ ref: register({ required: true }) }}
                fullWidth
                onChange={(e) => {
                  setFormValues({
                    ...formValues,
                    address: { ...formValues.address, city: e.target.value },
                  });
                  clearError('city')
                }}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <InputField
                color="secondary"
                label="Estado"
                placeholder="Informe o estado"
                name="state"
                error={!!errors.state}
                helperText="Estado inválido"
                value={formValues.address.state || ""}
                inputProps={{ ref: register({ required: true }) }}
                fullWidth
                onChange={(e) => {
                  setFormValues({
                    ...formValues,
                    address: { ...formValues.address, state: e.target.value },
                  });
                  clearError('state')
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <InputField
                color="secondary"
                label="País"
                placeholder="Informe o país"
                name="country"
                error={!!errors.country}
                helperText="País inválido"
                value={formValues.address.country || ""}
                inputProps={{ ref: register({ required: true }) }}
                fullWidth
                onChange={(e) => {
                  setFormValues({
                    ...formValues,
                    address: { ...formValues.address, country: e.target.value },
                  });
                  clearError('country')
                }}
              />
            </Grid>
          </Grid>

        </Grid>
      </div>

      <Grid item xs={12} style={{ textAlignLast: 'end', padding: '0px 20px 25px 20px' }}>
        <Grid style={{ borderTop: '1px solid rgb(52, 186, 146)', marginBottom: '20px' }}></Grid>
        <Button
          onClick={() => { handleSubmit(onSubmit(formValues)) }}
          fullWidth={xsSize ? true : false}
          size={xsSize ? 'xs' : 'medium'}
          color="secondary"
          variant="contained"
          style={{ marginRight: '30px' }}
        >
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Avançar&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </Button>
      </Grid>
    </>
  );
};

RentForm.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default RentForm;
